// extracted by mini-css-extract-plugin
module.exports =  {"root":"k54MwEQiq4VhZpnm2fFo","item":"bB_qhBFU36V97O8o_EUg","icon":"JN3kz6pToSEl4YjFxbah","skeletonRoot":"CVK2VipJ9j2aSaWvPqKM","skeletonTitle":"duVWun7krV1BKmOIs4ND"};